import { defineComponent as _defineComponent } from 'vue'
import PaymentScheduleCreator from '../../components/subscriptions/PaymentScheduleCreator.vue';
import OnBehalfOf from 'ah-common-lib/src/onBehalfOf/OnBehalfOf';
import { useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentScheduleView',
  props: { clientId: { type: String, required: false } },
  setup(__props) {

const props = __props;

const router = useRouter();


function onTradeCreated() {
  if (props.clientId) {
    router.replace('.');
  }
}

return { __sfc: true,router, props, onTradeCreated, PaymentScheduleCreator, OnBehalfOf }
}

})